import styled from 'styled-components';

export const ContainerAlertErrorMessage = styled.div`
  position: ${({ position }) => position ?? 'initial'};
  top: ${({ top }) => top ?? '0'}px;
  left: ${({ left }) => left ?? '0'}px;
  right: ${({ right }) => right ?? '0'}px;
  margin-bottom: 24px;

  font-size: 14px;
  background-color: #e9f1ff;
  padding: 12px 16px;
  border-radius: 8px;
  box-sizing: border-box;
  color: #1d3054;
  line-height: 1.4;

  .title-info-message {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    line-height: normal;
    svg {
      width: 20px;
    }
  }

  p {
    margin: 0;
    line-height: 1.4;
  }
`;
